import React, { Component } from "react";
import { RequestHeaders } from "../../../header-logo/request-header.component";
import { DataTable } from "../../../table/data-table/data-table-component";
import { connect } from "react-redux";
class InventoryPage extends Component {
    render() {
        return(
            <>
            <RequestHeaders headerTitle={this.props.headerTitle} />
            <div className="request-table data-table internal-data-table inventory-table-wrapper">
                {this.props.children}
                { !this.props.showTable && this.props.dataTable.map((item,id)=>
                    <DataTable key={id} id={id} item={item} header={item.HeaderItem} data={item.dataItem} customClassName="table-container" getData={this.props.getData} isDataLoaded={true} pages={this.props.pages} havePagination={true}/>
                )}                
             </div>
             </>
        )
    }
}

export default connect()(InventoryPage);